import React, { useEffect, useState, useRef } from "react";
import { Navigate, useNavigate } from 'react-router-dom';
import '../../App.css';
import {
	Avatar, Button, Box, Card, CircularProgress, FormControl, Grid, IconButton, Input, InputLabel, LinearProgress,
	Menu, MenuItem, Paper, 
	Select, Stack, Switch, TextField, Typography, FormControlLabel, Checkbox,
	imageListClasses
} from '@mui/material';
import Rotate90DegreesCwIcon from '@mui/icons-material/Rotate90DegreesCw';
import { AppHelper } from "../../AppHelper";
import { EssayHelper } from '../../helpers/essay.helper';
import UploadIcon from '@mui/icons-material/Upload';
import CloseIcon from '@mui/icons-material/Close';
import SentenceTransformImages from "./sentence-transform-images";
import SentenceTransformQSetExercise from "./sentence-transform-qset-exercise";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import PreviewIcon from '@mui/icons-material/Preview';
import PopPreview from './sentence-transform-qset-pop-preview';

export default function SentenceTransformForm({oUser, submitDone, tryAgain}) {
	const [record, setRecord] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [selectedImages, setSelectedImages] = useState([]);
	const [vMode, setVMode] = React.useState('NEW');
	const [startQuestion, setStartQuestion] = useState(false);
	const urlParams = new URLSearchParams(window.location.search);
	const urlSkill = urlParams.get('skill') || '';
	const [gradeList, setGradeList] = useState(urlParams.get('grade') || oUser.grade);
	const [groupedQuestions, setGroupedQuestions] = useState({});
	const [selectedQuestionSet, setSelectedQuestionSet] = useState({
		questionSetId: '', 
		questionSet: ''
	})
	const [index, setIndex] = useState("");
	const[questionItem, setQuestionItem] = useState("");
	const [recList, setRecList] = useState([]);
	const hasLoadedRef = useRef(false);
	const [popPreview, setPopPreview] = useState(false);
	const [showBack, setShowBack] = useState(false);
	const [showNext, setShowNext] = useState(false);
	const [isAnsweredQ, setIsAnsweredQ] = useState(false);
	const buttonVisibiltiy = {
		'true': 'visible', 
		'false': 'hidden'
	}

  useEffect(() => {
		setRecord({});
		fetchQuestionSets();
	  setRecList([]);
	  loadList();
  }, [oUser]);

	const handleFileChange = (event) => {
		if(event.target.files.length<1) return;
		var _files = [];
		for(var i=0; i<event.target.files.length; i++){
			_files.push({
				file: event.target.files[i],
				url: URL.createObjectURL(event.target.files[i]), 
				rotation: 0
			});
		}
		setSelectedImages(_files);
  };

  const handleUploadClick = () => {
    const inputImg = document.getElementById("file-input"); // Trigger file input
	inputImg.value = "";
	inputImg.click();
  };
  const handleRemoveClick = (index) =>{
	setSelectedImages(selectedImages.filter((_, i) => i !== index));
  };
	const file2B64 = async(argFile)=>{
		try {
			const reader = new FileReader();
			reader.readAsDataURL(argFile);
			const isHeicFile = argFile.name.toLowerCase().endsWith('.heic');
			const isCropped = false;
			if (isCropped) {//-- disabled crop fun for now (original code in scan-popup-v1)
			}
			else{
				await new Promise((resolveReader, rejectReader) => {
					reader.onload = () => {
						resolveReader();
					};
					reader.onerror = (error) => {
						rejectReader(error);
					};
				})
				const base64 = reader.result.split(",")[1];
				return { b64: base64, fileType:argFile.type, fileSize:argFile.size, isHeicFile:isHeicFile, align:false };
			}
		}
		catch (error) {
			console.error("Error converting image to base64:", error);
			return null;
		}
	}
	const onSubmit = async ()=>{
		if(!oUser){
			alert('Invalid user!');
			return;
		}
		for(var i=0; i<selectedImages.length; i++){
			var _img = selectedImages[i];
			if (!_img.b64) {
				const { b64 } = await file2B64(_img.file);
				_img.b64 = b64;
			}
			// _img.b64 = (await file2B64(_img.file)).b64;
		}
		const totalSize = selectedImages.reduce((acc, x) => {
			const base64String = x.b64;
			const sizeB = new Buffer(base64String, "base64").length;
			const sizeMB = (sizeB / (1024 * 1024)).toFixed(2);
			return acc + sizeMB;
		}, 0);
		if (totalSize > 30) {
			alert(
				"Total image size exceeds 30 MB. Please reduce the number or size of images."
			);
			setIsLoading(false); // Set loading state back to false
			return;
		}

		setIsLoading(true); // Set loading state to true
		const _imgArr = selectedImages.map((page) =>
			page.align ? page.alignB64 : page.b64
		);
		setVMode('SUBMITTING');
		
		var _res = await AppHelper.apiPost('api/exercise/sentenceTransform/transcribe', { token: oUser.token, images: _imgArr, profileId: oUser.profileId });
		if(_res.status){
			setRecord({exerciseId: _res.data.exerciseId});
			pageStatusCheck({exerciseId: _res.data.exerciseId});
		}
		AppHelper.apiAuditPost("EX-ADD", "");
	}

	const pageStatusCheck = async (argRec) => {
		var _res = await AppHelper.apiPost('api/exercise/sentenceTransform/get', {
			token: oUser.token,
			profileId: oUser.profileId,
			exerciseId: argRec.exerciseId
		});
		if (!_res.status) {
			console.error('API call failed:', _res);
			alert('ERROR');
			return;
		}
		var _rec = _res.data;
		setRecord(_rec);

		const pageCount = _rec.pageCount;
		const invalidImagesCount = _rec.pages.filter(page => page.status === 6).length;
		
		if(_rec.pages.find(x=>x.status == 0)){
			setVMode('PROCESSING');
			setTimeout(() => {
				pageStatusCheck(_rec);
			}, 1000*3);
		}
		else if (invalidImagesCount ===  pageCount) {
			alert('Transcription failed for all images. Please try again.');
			setVMode('ERROR');
			window.location.reload();
		}
		else {
			setVMode('DONE');
			submitDone({ code: 'NEW', argId: argRec.exerciseId });
		}

	}

	const openImageInNewTab = (blobUrl) => {
		window.open(blobUrl, "_blank", "noopener,noreferrer");
	};

	const handleGradeChange = (event) =>{
		setGroupedQuestions([]);
		setGradeList(event.target.value); 
	}

	useEffect(() => {
		fetchQuestionSets();
	}, [gradeList]);

    const fetchQuestionSets = async () => {
		if (!gradeList) {
			return;
		}
        setIsLoading(true);
		setSelectedQuestionSet({
			questionSetId: '', 
			questionSet: ''
		})
        try {
            const response = await AppHelper.apiPost('api/exercise/sentenceTransform/questionSet/getByGrade', {
				token: oUser.token, 
				grade: gradeList,
				skillTag: urlSkill
			  });
            if (response?.data.length == 0) {
                console.error("Failed to fetch question sets.");
                setGroupedQuestions([]);
            } else {
				const sortedGroupQuestion = response.data.sort((a, b) => 
				a.questionSetName.toLowerCase().localeCompare(b.questionSetName.toLowerCase(), 
																undefined, 
																{numeric: true, sensitivity: 'base'}))
                setGroupedQuestions(sortedGroupQuestion);
            }
        } catch (error) {
            console.error("Error fetching question sets:", error);
        } finally {
            setIsLoading(false);
        }
    };

	useEffect(() => {
		if (groupedQuestions.length > 0) {
			handleQuestionSetChange({target:  { value: `${groupedQuestions[0].questionSetId}:0`}});
		}
	}, [groupedQuestions]);

	const handleQuestionSetChange = (event) => {
		const [selectedId, index] = event.target.value.split(':');
		setIndex(index);
		if (event.target.value == 'No Question'){
			return;
		}
		const selectedSet = groupedQuestions[index];
		if (selectedSet == null){
			return;
		}
		setSelectedQuestionSet({
			questionSetId: selectedId, 
			questionSet: selectedSet
		});
		setPopPreview(true);
    };

	useEffect(() => {
		index <= 0 
			? setShowBack(false) 
			: setShowBack(true);
		index >= groupedQuestions.length - 1 
			? setShowNext(false) 
			: setShowNext(true);
	}, [selectedQuestionSet]);

	const handleStartClick = () => {
		if (selectedQuestionSet.questionSetId == ''){
			alert("Please select a question set. ");
			return;
		}
		if (recList.some(r => r.questionSetId === selectedQuestionSet.questionSetId)) {
			setIsAnsweredQ(true);
		}
		setStartQuestion(true);
		setVMode("GO2SET");
	};

	const handleBackClick = () => {
		if (index == ''){
			return;
		}
		const newIdx = index - 1;
		if (newIdx <= -1) {
			return;
		};
		setIndex(newIdx);
		const prevGrpId = groupedQuestions[newIdx]?.questionSetId;
		handleQuestionSetChange({target:  { value: `${prevGrpId}:${newIdx}`}});
	};

	const handleNextClick = () => {
		if (index == ''){
			return;
		}
		let newIdx = Number(index) + 1;
		if (newIdx >= groupedQuestions.length) {
			return;
		};
		setIndex(newIdx);
		const nextGrpId = groupedQuestions[newIdx]?.questionSetId;
		handleQuestionSetChange({target:  { value: `${nextGrpId}:${newIdx}`}});
	};

	const handleRotate = async (index) => {
	const page = selectedImages[index];
	const src = page.b64
		? `data:image/jpeg;base64,${page.b64}`
		: page.url;

	const image = new Image();
	image.src = src;

	try {
		await new Promise((res, rej) => {
		image.onload = res;
		image.onerror = rej;
		});

		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');
		canvas.width = image.height;
		canvas.height = image.width;

		ctx.translate(canvas.width / 2, canvas.height / 2);
		ctx.rotate(Math.PI / 2);
		ctx.drawImage(image, -image.width / 2, -image.height / 2);

		const dataUrl = canvas.toDataURL('image/jpeg');

		setSelectedImages((prev) =>
		prev.map((p, i) =>
			i === index
			? {
				...p,
				b64: dataUrl.split(',')[1],
				url: dataUrl,
				}
			: p
		)
		);
	} catch (err) {
		console.error('Error rotating image:', err);
	}
	};
	const handleTryAgainClick = () => {
		tryAgain({ code: 'AGAIN' });
	}

	const loadList = async (argExerciseId=null) => { 
		setIsLoading(true); 
		var _res = await AppHelper.apiPost('api/exercise/sentenceTransform/list', 
			{token: oUser.token, profileId: oUser.profileId}); 
			if(!_res || !_res.status){ 
				setRecList([]); 
				return; 
			} 
			var _list = _res.data; 
			setRecList(_list); 
		setIsLoading(false); 
	};

	const onClosePreview = () => {
		setPopPreview(false);
	}

	return(
		<>
    <Box sx={{ flexGrow: 1, backgroundColor:'#fff' }}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box sx={{fontWeight:'bold', fontFamily: "'Playpen Sans', cursive", fontSize:'2rem', textAlign:'center'}}>
                    Sentence Transformation
                </Box>
            </Grid>
            {vMode === 'NEW' &&
                <>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: "0"}}>
                    <Typography sx={{fontSize:'1.3rem', fontWeight: 'bold', color: "rgba(19, 130, 117, 1)", }}>
						Select An Exercise
					</Typography>
                </Grid>
                    <Grid item xs={12} md={12}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
							<FormControl fullWidth>
								<InputLabel>Grade</InputLabel>
								<Select
									value={gradeList}
									label="Grade"
									onChange={handleGradeChange}
								>
									<MenuItem value={'P1'}>Primary 1</MenuItem>
									<MenuItem value={'P2'}>Primary 2</MenuItem>
									<MenuItem value={'P3'}>Primary 3</MenuItem>
									<MenuItem value={'P4'}>Primary 4</MenuItem>
									<MenuItem value={'P5'}>Primary 5</MenuItem>
									<MenuItem value={'P6'}>Primary 6</MenuItem>
									<MenuItem value={'S1'}>Secondary 1</MenuItem>
									<MenuItem value={'S2'}>Secondary 2</MenuItem>
									<MenuItem value={'S3'}>Secondary 3</MenuItem>
									<MenuItem value={'S4'}>Secondary 4 (NA)</MenuItem>
									<MenuItem value={'S4E'}>Secondary 4 Express</MenuItem>
									<MenuItem value={'S5'}>Secondary 5</MenuItem>
								</Select>
							</FormControl>
							</Grid>
							<Grid item xs={12}>
							<FormControl fullWidth>
								<InputLabel>
									{selectedQuestionSet.length > 0 ? "Question Set Name" : "No Question Available"}
								</InputLabel>
								<Select
									value={selectedQuestionSet.questionSetId 
											? `${selectedQuestionSet.questionSetId}:${index}` 
											: ""}
									label="Question Set Name"
									onChange={handleQuestionSetChange}>
									{!isLoading && groupedQuestions && groupedQuestions.length > 0 ? (
									groupedQuestions.map((q, index) => (
									<MenuItem key={q.questionSetId} value={`${q.questionSetId}:${index}`}>
									<Box sx={{ display: 'flex', alignItems: 'center' }}>
										<Typography variant="body1">{q.questionSetName}</Typography>
										{recList.some(r => r.questionSetId === q.questionSetId) && (
										<Box
											sx={{
											backgroundColor: 'green',
											borderRadius: '50%',
											width: 24,
											height: 24,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											ml: 1
											}}
										>
											<CheckRoundedIcon sx={{ color: 'white', fontSize: 16 }} />
										</Box>
										)}
									</Box>
									</MenuItem>
									))
									) : (
									<MenuItem value="No Question">No Question Available</MenuItem>
									)}
								</Select>
							</FormControl>
							</Grid>
						
							{selectedQuestionSet.questionSetId.length != 0 &&
							<>
							<Grid
							container
							direction="row"
							alignItems="center"
							justifyContent="center"
							sx={{marginTop: '20px'}}
							>
							  <Grid item>
								<Button
								className="app-btn-bg"
								sx={{
									margin: '0 5px 22px 5px',
									width: '100px',
									visibility: buttonVisibiltiy[showBack]
								}}
								onClick={handleBackClick}
								color="info"
								variant="contained"
								size="large"
								>
								BACK
								</Button>
							  </Grid>
							  <Grid item>
								<Button
								className="app-btn-bg"
								sx={{
									margin: '0 5px 22px 5px',
									width: '100px'
								}}
								onClick={handleStartClick}
								color="info"
								variant="contained"
								size="large"
								>
								START
								</Button>
							  </Grid>
							  <Grid item>
								<Button
								className="app-btn-bg"
								sx={{
									margin: '0 5px 22px 5px',
									width: '100px',
									visibility: buttonVisibiltiy[showNext]
								}}
								onClick={handleNextClick}
								color="info"
								variant="contained"
								size="large"
								>
								NEXT
								</Button>
							  </Grid>
							</Grid>
							</>
							}
						</Grid>
                    </Grid>

					{/* Preview */}
					<Grid item xs={12} md={12}>
							{selectedQuestionSet.questionSetId.length != 0 ? (	
								<Paper elevation={3}
									sx={{minHeight: 400, 
										padding:2, 
										display: 'flex', 
										alignItems: 'left', 
										justifyContent: 'left'
								}}>
								  <PopPreview
									open={popPreview}
									onClose={onClosePreview}
									question={selectedQuestionSet}
								  />
								</Paper>
							) : (	
								<Paper elevation={3}
								sx={{minHeight: 95, 
									padding:2, 
									display: 'flex', 
									alignItems: 'center', 
									justifyContent: 'center'
								}}>
									<>Question Set preview will be shown here. </>
								</Paper>
							)}
					</Grid>

			<Grid item xs={12} style={{ display:'flex', textAlign: "center", marginTop: "1rem", justifyContent:'center', alignItems: 'center' }}>
			</Grid>
				<Grid container item xs={12} justifyContent="left" style={{}}>
					
					<Grid item xs={12} style={{ textAlign: 'left', marginTop: "0"}}>
                    	<Typography sx={{fontSize:'1.3rem', fontWeight: 'bold', color: "rgba(19, 130, 117, 1)", marginBottom: "1rem"}}>
							Upload Your Own Exercise Image
						</Typography>
					</Grid>
					<div style={{ display:'flex', justifyContent:'left', alignItems: 'left', width: '100%'}}>
						<IconButton
							onClick={handleUploadClick}
							style={{
								width: "80px",
								height: "80px",
								backgroundColor: "rgba(19, 130, 117, 1)",
								color: "white",
								borderRadius: "50%",
								boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
							}}
						>
							<UploadIcon style={{ fontSize: "40px" }} />
						</IconButton>
					</div>
					<Box
					sx={{
						display: 'flex',
						flexDirection: 'column', 
						alignItems: 'left', 
						mt: 2, 
						textAlign: 'left',
					}}
					>
						{/* Image Preview */}
						{selectedImages.length == 0 &&
							<div>
							<Box sx={{fontWeight:'normal', textAlign:'left', marginBottom:'1rem'}}>
								<Typography sx={{fontSize:'1.3rem', fontStyle: "italic"}}>Upload the photo(s) of your handwritten or printed questions and answers.</Typography>
								<Typography sx={{fontSize:'1.3rem', fontStyle: "italic"}}>Below is the sample photo.</Typography>
							</Box>
							<img src="../sample-image.png" alt="Sample" 
								style={{
										maxWidth: "100%", 
										height: "20rem",
										objectFit: "cover",
										marginRight: "5px",
										borderRadius: "10px",
										border: "2px solid #ccc",
										borderRadius:'5%'
									}} 
									onClick={() => openImageInNewTab("../sample-image.png")}/>
							</div>
						}

						{selectedImages.length > 0 && (
							<Box sx={{fontWeight:'normal', textAlign:'left', marginBottom:'1rem'}}>
								<Typography sx={{fontSize:'1.3rem', fontStyle: "italic"}}>Please rotate each image so it appears upright before submitting. </Typography>
							</Box>
						)}
						
						<Box
							sx={{
							display: 'flex',
							justifyContent: 'left',
							flexWrap: 'wrap',
							gap: 2, 
							}}
						>
						{selectedImages && selectedImages.map((img, iImg)=>(
							<div>
								<IconButton
									size = "small"
								onClick={() => handleRotate(iImg)}
								sx={{borderRadius: 0}}
								>
										<Rotate90DegreesCwIcon
										color="primary"
										sx={{marginRight: '6px'}}
										/>
								<Typography
									variant="body2"
									component="span"
									sx={{ml: 1}}
								>
									Rotate image clockwise
								</Typography>
								</IconButton>
							<div key={iImg} style={{position: 'relative', margin: '5px', width: "200px", height: "200px"}}>
								<img
									src={img.url}
									alt="Preview"
									style={{
										width: "200px",
										height: "200px",
										objectFit: "cover",
										marginRight: "5px",
										borderRadius: "10px",
										border: "2px solid #ccc"
									}}
								/>
								<IconButton
									onClick={() => handleRemoveClick(iImg)}
									style={{
										width: "25px", 
										height: "25px",
										position: 'absolute',
										top: 0, 
										right: 0, 
										color: 'rgba(255, 255, 255, 0.8)', 
										backgroundColor: 'rgba(0, 0, 0, 0.6)', 
										margin: '5px', 
										'&:hover': {
											backgroundColor: 'rgba(0, 0, 0, 0.8)',
										},
									}}>
										<CloseIcon />
									</IconButton>
							</div>
							</div>
						))}

						<input
							id="file-input"
							type="file"
							accept="image/*"
							style={{ display: "none" }}
							onChange={handleFileChange}
							multiple
						/>
					</Box>
					</Box>
					{ selectedImages && selectedImages.length>0 && 
					<Grid item xs={12} style={{ display:'flex', textAlign: "left", marginTop: "1rem", justifyContent:'left', alignItems: 'left' }}>
						<Button className="app-btn-bg" sx={{
							margin:'0 5px 22px 5px'
							}}
							onClick={onSubmit} color="info" variant="contained" size="large">
							Submit
						</Button>
					</Grid>
					}
				</Grid>
			<Grid container item xs={12} style={{ display:'flex', textAlign: "left", justifyContent:'left', alignItems: 'left' }}>
				<Grid item xs={12} style={{ textAlign: 'left', marginTop: "0"}}>
                	<Typography sx={{fontSize:'1.3rem', fontWeight: 'bold', marginBottom: "1rem", color: "rgba(19, 130, 117, 1)", }}>
						Re-try Past Mistakes
					</Typography>
				</Grid>
				<Box sx={{fontWeight:'normal', textAlign:'left', marginBottom:'1rem'}}>
					<Typography sx={{fontSize:'1.3rem', fontStyle: "italic"}}>EssayAce AI customizes practice questions based on your past submissions, learns from your previous mistakes, and helps you improve through targeted practice.</Typography>
				</Box>
				<div style={{ display:'flex', justifyContent:'left', alignItems: 'left', width: '100%'}}>
				<Button className="app-btn-bg" sx={{
					margin:'0 5px 22px 5px',
					}}
					onClick={handleTryAgainClick} color="info" variant="contained" size="large">
					RE-TRY PAST MISTAKES
				</Button>
				</div>
			</Grid>
				</>
				}
				{ (vMode == 'PROCESSING' || vMode == 'DONE') &&
				<>
				<Grid item xs={12}>
          <LinearProgress color="info" sx={{ marginTop: '1rem' }} />
				</Grid>
				<Grid item xs={12} mt={5} align={'center'}>
					{ record && record.pages && record.pages.map((p, iP)=>(
						<Box display={'flex'} alignItems={'center'} justifyContent={'center'} key={'img_i_' + iP}>
                {p.status !== 1 &&
                  <CircularProgress />
                }
                {p.status === 1 &&
                  (
                    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                      <CircularProgress variant="determinate" value={100} color="success" />
                      <Box
                        sx={{
                          top: 0, left: 0, bottom: 0, right: 0, position: 'absolute',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}
                      >
                        <Typography variant="caption" component="div" color="text.info">{`100%`}</Typography>
                      </Box>
                    </Box>
                  )
                }
                <Typography sx={{ marginLeft: '10px' }}>Page {iP+1}</Typography>
              </Box>
					))}
				</Grid>
				</>
				}
				{ vMode == 'SUBMITTING' &&
				<>
				<Grid item xs={12}>
          <LinearProgress color="info" sx={{ marginTop: '1rem' }} />
				</Grid>
				<Grid item xs={12} mt={5} align={'center'}>
					<CircularProgress />
				</Grid>
				</>
				}
				{ vMode == 'GO2SET' &&
					<SentenceTransformQSetExercise 
					question={selectedQuestionSet}
					oUser={oUser} 
					submitDone={submitDone}
					isAnsweredQ={isAnsweredQ}
					/>
				}
			</Grid>
		</Box>
		</>
	)
}